import React from 'react';
import { Navigation, Phone } from 'lucide-react';
import { getAltText } from '../../data/images';
import { openSecureUrl, ALLOWED_DOMAINS } from '../../utils/security';

const PhoneWhatsAppLink = ({ phoneNumber, className = "" }) => {
  const handlePhoneClick = () => {
    const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
    const whatsappUrl = `https://wa.me/${cleanNumber}`;
    
    openSecureUrl(whatsappUrl, ALLOWED_DOMAINS.WHATSAPP);
  };

  return (
    <button 
      onClick={handlePhoneClick}
      className={`text-tilcara-orange hover:text-orange-600 transition-colors duration-200 flex items-center space-x-1 ${className}`}
    >
      <Phone className="h-4 w-4" />
      <span>{phoneNumber}</span>
    </button>
  );
};

const LocationSection = ({ language, currentContent }) => {
  // Usar la imagen de la fachada del hostel
  const facadeImage = {
    src: '/assets/hostel-front-sign-hostel-tilcara.jpg',
    altEs: 'Fachada de Casa Colores Hostel con cartel colorido',
    altEn: 'Casa Colores Hostel facade with colorful sign'
  };

  return (
    <section id="location" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-dancing">
            {currentContent.location.title}
          </h2>
          <p className="text-xl text-tilcara-orange font-medium">
            {currentContent.location.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="text-gray-700 leading-relaxed space-y-3">
                <div className="flex items-center space-x-2">
                  <span>Barrio Radio Vieja Estación, Tilcara, Jujuy</span>
                </div>
                <div className="flex items-center space-x-2">
                  <PhoneWhatsAppLink phoneNumber="+54 388 331-6388" />
                </div>
              </div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                <Navigation className="h-5 w-5 text-tilcara-orange mr-2" />
                {currentContent.location.directionsTitle}
              </h3>
              <p className="text-gray-600 mb-4">
                {currentContent.location.directions}
              </p>
            </div>
          </div>

          <div className="space-y-6">
            {/* Featured Location Image */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img
                src={facadeImage.src}
                alt={getAltText(facadeImage, language)}
                className="w-full h-64 object-cover"
              />
              <div className="p-4">
                <h4 className="font-semibold text-gray-900 mb-2">
                  {currentContent.location.easyToFind}
                </h4>
                <p className="text-gray-600 text-sm">
                  {currentContent.location.houseDescription}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Google Maps - Full Width */}
        <div className="mt-16">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.853550422258!2d-65.4000606!3d-23.573702700000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9404cb42c619d3a3%3A0xb11b157f92605800!2sHOSTEL%20CASA%20COLORES%20TILCARA!5e0!3m2!1ses-419!2sar!4v1753745876582!5m2!1ses-419!2sar"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="HOSTEL CASA COLORES TILCARA"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
